export const GET_JOBS = "GET_JOBS";
export const GET_JOBS_GLOBAL = "GET_JOBS_GLOBAL";
export const ADD_JOB = "ADD_JOB";
export const UPDATE_JOB = "UPDATE_JOB";
export const DELETE_JOB = "DELETE_JOB";
export const JOB_SKILLS = "JOB_SKILLS";
export const GET_LINKED_BRANCHES = "GET_LINKED_BRANCHES";
export const GET_REMARKS = "GET_REMARKS";
export const ADD_REMARKS = "ADD_REMARKS";
